module.exports = __webpack_public_path__ + "static/media/120.d35b862f.jpg";